import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface ChatbotChatParams {
  message: string
  conversationId?: string
}

interface PendingAction {
  toolName: string
  args: Record<string, unknown>
  description: string
  // The note or the person an update / delete is about (absent from older servers).
  targetLabel?: string
}

interface ChatbotChatResponse {
  conversationId: string
  response: string
  pendingActions?: PendingAction[]
  title: string
}

const sendChatMessage = async (params: ChatbotChatParams): Promise<ChatbotChatResponse> => {
  const { data } = await api.post<ChatbotChatResponse>('/ft_chatbot/chat', params)
  return data
}

export const useFtChatbotChat = () => {
  return useMutation<ChatbotChatResponse, Error, ChatbotChatParams>({
    mutationFn: sendChatMessage,
  })
}
